import type { TasksState } from './tasksSlice';

export const getHiddenTaskReminders = (state: { tasks: TasksState }) => state.tasks.hiddenTaskReminders;
export const getSelectedTaskId = (state: { tasks: TasksState }) => state.tasks.selectedTaskId;
